// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1GnKU","label":"Section_label__37VX0","contentWrap":"Section_contentWrap__3lPyl","footer":"Section_footer__31GHa","footerInner":"Section_footerInner__3722Z"};